import { render, staticRenderFns } from "./LeadsList.vue?vue&type=template&id=52ae7270&scoped=true&"
import script from "./LeadsList.vue?vue&type=script&lang=js&"
export * from "./LeadsList.vue?vue&type=script&lang=js&"
import style0 from "./LeadsList.vue?vue&type=style&index=0&id=52ae7270&lang=scss&scoped=true&"
import style1 from "./LeadsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ae7270",
  null
  
)

export default component.exports